import './styles.scss'

import { ChevronRightIcon } from '@/components/Icons'

function ServiceTitle({ name, onClick, hasRightArrow = true }) {
  return (
    <button
      className="service-case__titleButton--mobile"
      type="button"
      onClick={onClick}
    >
      <div className="service-item">
        <span>{name}</span>
        {hasRightArrow ? <ChevronRightIcon /> : null}
      </div>
    </button>
  )
}

export default ServiceTitle
